export default {
  man: [
    [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
    [`Российский размер`, `44-46`, `46-48`, `48-50`, `50-52`, `52-54`, `54-56`],
    [`Грудь`, `49`, `52`, `55`, `58`, `61`, `64`],
    [`Длина`, `70`, `72`, `74`, `76`, `78`, `80`]
  ],
  woman: [
    [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
    [`Российский размер`, `42-44`, `44-46`, `48`, `50`, `52`],
    [`Грудь`, `40`, `44`, `48`, `50`, `54`],
    [`Длина`, `60`, `62`, `64`, `65`, `67`]
  ]
};
